<template>
  <div
    class="d-flex justify-end align-center ga-4"
    :data-qa="normalizeQa(dataQaPrefix ? `${dataQaPrefix}__container` : undefined)"
  >
    <AGButtonIcon
      icon="mdi-page-first"
      size="md"
      :disabled="isFirstPage"
      :data-qa="normalizeQa(dataQaPrefix ? `${dataQaPrefix}__btn-first` : undefined)"
      @click="goFirstPage"
    />
    <AGButtonIcon
      icon="mdi-chevron-left"
      size="md"
      :disabled="isFirstPage"
      :data-qa="normalizeQa(dataQaPrefix ? `${dataQaPrefix}__btn-prev` : undefined)"
      @click="goPreviousPage"
    />
    <span class="ag-pagination__text" :data-qa="normalizeQa(dataQaPrefix ? `${dataQaPrefix}__text` : undefined)">
      {{ currentPage }} de {{ totalPages }} {{ text }}
    </span>
    <AGButtonIcon
      icon="mdi-chevron-right"
      size="md"
      :disabled="isLastPage"
      :data-qa="normalizeQa(dataQaPrefix ? `${dataQaPrefix}__btn-next` : undefined)"
      @click="goNextPage"
    />
    <AGButtonIcon
      icon="mdi-page-last"
      size="md"
      :disabled="isLastPage"
      :data-qa="normalizeQa(dataQaPrefix ? `${dataQaPrefix}__btn-last` : undefined)"
      @click="goLastPage"
    />
  </div>
</template>

<script>
import AGButtonIcon from '@/components/common/AGButtonIcon';
import UtilsString from '@/utils/UtilsString';

export default {
  components: {
    AGButtonIcon,
  },
  emits: ['click:first-page', 'click:previous-page', 'click:next-page', 'click:last-page'],
  props: {
    text: {
      type: String,
      default: '',
    },
    totalPages: {
      type: Number,
      required: true,
    },
    currentPage: {
      type: Number,
      required: true,
    },
    dataQaPrefix: {
      type: String,
      default: '',
    },
  },
  computed: {
    isFirstPage() {
      return this.currentPage === 1;
    },
    isLastPage() {
      return this.currentPage === this.totalPages;
    },
  },
  methods: {
    normalizeQa: UtilsString.normalizeQa,
    goFirstPage() {
      this.$emit('click:first-page');
    },
    goPreviousPage() {
      this.$emit('click:previous-page');
    },
    goNextPage() {
      this.$emit('click:next-page');
    },
    goLastPage() {
      this.$emit('click:last-page');
    },
  },
};
</script>

<style scoped lang="scss">
.ag-pagination__text {
  font-size: $font-size-xs;
  font-weight: $font-weight-regular;
  color: $neutral-color-high-medium;
}
</style>
